import type { BackendRouteDefinition } from '../types';
import type { GetPaymentInstrumentsForFirmClient } from '@cloudFunctions/types/clientToFirmPayments/getPaymentInstrumentsForFirmClient';

export const getPaymentInstrumentsForFirmClientRoute = {
  transport: 'api',
  method: 'GET',
  path: '/clients/payment-instruments',
  query: ({ environment }: GetPaymentInstrumentsForFirmClient.RequestData) => ({
    environment,
  }),
} as const satisfies BackendRouteDefinition;
